<!-- 由 Dioa 创建于 2022-06-24 星期五 -->
<template>
  <div class="result-chart" id="result-chart"> </div>
</template>

<script>
import * as echarts from 'echarts'
export default {
  name: 'result-chart',

  components: {},

  props: {},

  data() {
    return {
      average: [60, 88, 85, 87, 92, 80],
      your: [75, 81, 96, 80, 75, 96]
    }
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    initChart(your, average) {
      option = {
        legend: {
          show: false
        },
        grid: {
          containLabel: true
        },
        radar: {
          shape: 'circle',
          indicator: (function () {
            var res = []
            var indicatorList = ['运动', '饮食', '体质', '情绪', '习惯', '睡眠']
            indicatorList.forEach((item, index) => {
              res.push({ text: `${item} ${your[index]}`, max: 100 })
            })
            return res
          })(),
          axisName: {
            color: '#363D54',
            fontSize: '12px',
            fontWeight: '600'
          }
        },
        series: [
          {
            type: 'radar',
            symbol: 'none',
            lineStyle: {
              width: 3
            },
            data: [
              {
                value: average,
                name: '同龄人平均得分',
                itemStyle: {
                  color: '#E2E3EA'
                },
                emphasis: {
                  disabled: true
                },
                areaStyle: {
                  color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    {
                      color: 'rgba(226, 227, 234, 1)',
                      offset: 0
                    },
                    {
                      color: 'rgba(226, 227, 234, 1)',
                      offset: 1
                    }
                  ])
                }
              },
              {
                value: your,
                name: '你的得分',
                itemStyle: {
                  color: '#6759FF'
                },
                emphasis: {
                  disabled: true
                },
                areaStyle: {
                  color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                    {
                      color: 'rgba(103, 89, 255, 0.1)',
                      offset: 0
                    },
                    {
                      color: 'rgba(103, 89, 255, 0.32)',
                      offset: 1
                    }
                  ])
                }
              }
            ]
          }
        ]
      }

      var chartDom = document.getElementById('result-chart')
      var myChart = echarts.init(chartDom, null, { renderer: 'svg' })
      var option
      option && myChart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.result-chart {
  height: vw(210);
}
</style>
